// react
import React, { useEffect } from 'react';
// components
// import { Modal } from 'antd';
// utils & api
// import { getEnv, getValue } from './utils';
// import { getEnv } from './utils';
// import { checkBookingPermission } from './api/request';

const App = () => {
    /**
     * @description 无权限弹窗
     */
    // const permissionError = () => {
    //     Modal.error({
    //         title: '抱歉，您尚未开通私教服务',
    //         content: '需开通才可以享受私教服务',
    //         onOk() {
    //             window.location.href = `//${getEnv()}v.gaodun.com/space#/`;
    //         },
    //         okText: '返回学习空间',
    //     });
    // };

    /**
     * @description 判断是否有私教权限
     */
    // const _checkBookingPermission = async () => {
    //     const res = await checkBookingPermission();
    //     if (res.data.http_code === 200) {
    //         Modal.info({
    //             title: '登录信息已失效，请重新登录',
    //             okText: '确定',
    //             onOk() {
    //                 window.location.href = `//${getEnv()}v.gaodun.com/member/login.html`;
    //             }
    //         });
    //         return;
    //     }
    //     const permission = getValue(() => res.data.data.permission);
        
    //     !permission && permissionError();
    // };

    /**
     * @description 生命周期 api请求
     */
    useEffect(() => {
        // _checkBookingPermission();
    }, []);

    return (
        <></>
    );
};

export default App;